import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorStateMatcher } from '@angular/material/core';
import {Router} from '@angular/router';
import {ReportsSubscriptionsService} from 'src/app/reports-subscriptions/reports-subscriptions.service';
import {CaexService} from 'src/app/services/caex.service';
import {AlertComponent} from 'src/app/shared/dialogs/alert/alert.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-caex-order',
  templateUrl: './caex-order.component.html',
  styleUrls: [ './caex-order.component.scss' ]
})
export class CaexOrderComponent implements OnInit {

  public memberForm: FormGroup;

  public dataSourceProducts: MatTableDataSource<any>
  public displayedColumnsProducts: string[] = [ 'name' ];

  public arrayMemberOrder: any[] = []
  public arrayAllProducts: any;

  public categories: any[] = []

  public spinner: boolean;

  public alreadySubscribed: boolean = false;

  constructor (
    public _caexService: CaexService,
    private router: Router,
    private dialog: MatDialog,
    private _reportsSubscriptionsService: ReportsSubscriptionsService,
    private snackBar: SnackBarIconService
  ) {

  //  this.categories = this._reportsSubscriptionsService.loadCategories()
    this._reportsSubscriptionsService.loadCategories()
    .subscribe((result)=>{
      this.categories = []

      result.forEach((item)=>{
        this.categories.push({
          'id': item.id,
          'name': item.data().name
        })
      })

      if (!this._caexService.currentMember) {
        this.router.navigate([ 'caex' ]);
      } else {
       // console.log(JSON.stringify(this._caexService.currentMember))
      }
  
      this.getOrdersByMemberId(this._caexService.currentMember.id)

    })



  }

  ngOnInit () {
  }

  getOrdersByMemberId (member_id) {

    this._caexService.getOrdersByMemberId(member_id)
      .subscribe((result) => {

        this.arrayMemberOrder = []

        result.forEach((item: any) => {

          let id = item.data().product_id

          // 50º Congresso SBCCV • 2024
          if (id == "2vgQyqXZWjsrYWngGV6A" ) { //  id == "sVNv9CdC61Itab0lSock"  CURSO DE TAVI 2024
            let order: any
            order = item.data()
            order.id = item.id

            this.arrayMemberOrder.push(order)

          }

        })

        if (this.arrayMemberOrder.length > 0) {
          console.log("JA ESTÁ INSCRITO")
          this._caexService.memberOrders = this.arrayMemberOrder
          this.alreadySubscribed = true;
        } else {
          this.alreadySubscribed = false;
          this.load50Congress()
        }

      })

  }

  load50Congress () {

    this._caexService.load50Congress()
      .subscribe((item) => {

        this.arrayAllProducts = []

        this.arrayAllProducts.push({
          'id': item.id,
          'name': item.data().name,
          'requirements': item.data().requirements
        })

        this.dataSourceProducts = new MatTableDataSource(this.arrayAllProducts);

      })
  }

  getProduct (product) {

    let ordered = this.arrayMemberOrder.find((e) => {
      return e.product_id == product.id
    })

    if (ordered) {
      this.dialog.open(AlertComponent, {
        width: '450px',
        height: '270px',
        panelClass: 'custom-dialog-container',
        data: {title: "Alerta", message: this._caexService.currentMember.name + "<br><br>já possui<br><br>" + ordered.product_name}
      });
    } else {
      this._caexService.currentProduct = product
      this.router.navigate([ 'caex-products' ]);
    }

  }

  gotoToten(doc){
    this.router.navigate([ 'toten/' + doc ]);
  }

  goBack () {
    this.router.navigate([ 'caex-member' ]);
  }

}
